import { useNavigate } from 'react-router-dom';
import { TourStep } from '../types/TourTypes';

/**
 * Hook para gerenciar navegação entre etapas do tour
 */
export const useTourNavigation = (hasStartedBefore: boolean) => {
  const navigate = useNavigate();

  const navigateToStep = (step: TourStep, isFirstStep: boolean) => {
    // Step create_workspace: destaca o botão "Add Workspace" na navbar sem navegar
    // (o botão está presente em qualquer rota autenticada via Navbar).
    if (step.id === 'create_workspace') {
      return 100;
    }

    // Step upload_knowledge sempre navega para /knowledge?tab=files
    if (step.id === 'upload_knowledge') {
      navigate(`${step.route}?tab=files`);
      return 500;
    }

    // Step create_integration sempre navega para /integrations
    if (step.id === 'create_integration') {
      navigate(step.route);
      return 500;
    }

    // Step playground_chat sempre navega para /playground
    if (step.id === 'playground_chat') {
      navigate(step.route);
      return 500;
    }

    // Step install_agent sempre navega para a área Workflows (/workflows)
    if (step.id === 'install_agent') {
      navigate(step.route);
      return 500;
    }

    // Para outros steps: Na primeira vez que o tour é executado e é o primeiro step,
    // não navega (usuário já está na tela certa)
    const shouldNavigate = hasStartedBefore || !isFirstStep;

    if (shouldNavigate) {
      navigate(step.route);
    }

    // Retorna um delay para esperar a navegação e renderização do DOM
    return shouldNavigate ? 500 : 100;
  };

  return { navigateToStep };
};
